import { Helmet } from "react-helmet-async";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Calendar, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const BlogueArticle = () => {
  const { slug } = useParams();

  const { data: post, isLoading } = useQuery({
    queryKey: ["blog-post", slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("blog_posts")
        .select("*")
        .eq("slug", slug)
        .eq("published", true)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return (
      <div className="py-16 text-center">
        <p className="text-muted-foreground">Chargement de l'article...</p>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="py-16 text-center">
        <h1 className="text-4xl font-bold mb-4">Article non trouvé</h1>
        <p className="text-muted-foreground mb-8">Cet article n'existe pas ou n'est plus disponible.</p>
        <Link to="/blogue">
          <Button>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Retour au blogue
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{post.title} - Agroref</title>
        <meta name="description" content={post.excerpt || post.title} />
      </Helmet>

      <article className="max-w-4xl mx-auto">
        <Link to="/blogue">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Retour au blogue
          </Button>
        </Link>

        {post.image_url && (
          <div className="aspect-video overflow-hidden rounded-lg mb-8">
            <img 
              src={post.image_url} 
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        <header className="mb-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{post.title}</h1>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <time dateTime={post.created_at}>
              {new Date(post.created_at).toLocaleDateString("fr-FR", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </time>
          </div>
        </header>

        <div 
          className="prose prose-lg max-w-none"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </article>
    </>
  );
};

export default BlogueArticle;
